// import SensorDataTable from "../hocs/SensorDataTable"; 
// import GaugeMain from "../hocs/GaugeMain";
// import Chart1 from "../Charts/Chart1";
// import DGLive from "../hocs/DGLive";
// import DGConsumption from "../hocs/DGConsumption";
// import Gauge1 from "../hocs/Gauge1";
// import Gauge2 from "../hocs/Gauge2";
// import Gauge3 from "../hocs/Gauge3";
// import Gauge4 from "../hocs/Gauge4";
// import { useStoreUpdaterWithAPI } from "../../../Hooks/UseStoreUpdaterWithApi";
// import { useEffect, useState } from "react";
// import { Button, Form, Modal, notification, Select, Space } from "antd";
// import { APIConstants } from "../../../Common/APIConstants";
// import { useSelector } from "react-redux";
// import { MoreOutlined, CloseOutlined } from "@ant-design/icons";


  
// const SensorOne = (props) => {
//   const isdarkMode=props.theme;
//   const [refetch,setRefetch]=useState(false)
//     const {makeRequest} = useStoreUpdaterWithAPI();
//   const [isModalOpen, setIsModalOpen] = useState(false);
//     const showModal = () => {
//       setIsModalOpen(true);
//     };
//     const handleOk = () => {
//       setIsModalOpen(false);
//     };
//     const handleCancel = () => {
//       setIsModalOpen(false);
//     };

//     const handleNotification = (msg, type = "success") => {
//       notification.open({
//         message: msg,
//         type: type, 
//         placement: 'top',  
//         duration: 3, 
//       });
//     };


//       const UpdateGauge = (formValues) => {
//         console.log(formValues);
//         const url = `${APIConstants.UPDATE_GAUGE_DETAILS}`;
//         console.log(url);
    
//         makeRequest({
//           type: APIConstants.POST,
//           url: url,
//           body: formValues,
//         }).then((res) => {
//           console.log(res);
//           // setRefetch(!refetch)
//           handleNotification(res.msg || "Updated successfully!",'success');
//           setRefetch(!refetch);
//         }).catch((err) => {
//           handleNotification("Something went wrong!",'error');
    
//         });
//       };

//   return (
//     <div className="flex flex-col justify-center bg-dark-echarts my-5 h-fit overflow-x-hidden ">
//     <div className="flex xl:flex-nowrap flex-wrap  justify-between bg-dark-echarts gap-5 gap-y-5 m-5">   
//       <DGLive   theme={props.theme} title='Production Data' /> 
//       <DGConsumption   theme={props.theme} title='Production Chart' />     
//     </div> 
//     <div className="flex xl:flex-nowrap flex-wrap  justify-between bg-dark-echarts gap-5 gap-y-5 m-5">    
//       <SensorDataTable   theme={props.theme} title='EB Incomer' /> 
//       <Chart1   theme={props.theme} title='Consumption Trend' />    
//     </div>    
//     <div className="flex-col  xl:flex-nowrap flex-wrap m-5  bg-dark-echarts  shadow-allsides overflow-hidden  ">   
//     <div
//         className=" w-full mb-0 p-1  "
//         style={{ 
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//         }}
//       >
//         <p
//           className={`${
//             isdarkMode === "dark" ? "text-neutral-100" : "text-neutral-900"
//           }  md:text-xl px-3 font-bold `}
//           style={{ margin: 0 }}
//         >
//           Gauges

//         </p>
       
//           <a onClick={() => showModal()}>
//             <Space>
//               <MoreOutlined
//                 className={`${
//                   isdarkMode === "dark" ? "text-neutral-100" : "text-neutral-600"
//                 } px-3 font-extrabold`}
//               />
//             </Space>
//           </a>
//       </div>
//       <div className="flex w-full gap-5 gap-y-5 mb-5 xl:flex-nowrap flex-wrap justify-evenly ">
//       <Gauge1   theme={props.theme} title='Live Voltage' refetch={refetch} /> 
//       <Gauge2   theme={props.theme} title='Live Demand' refetch={refetch}   /> 
//       <Gauge3   theme={props.theme} title='Live Current'  refetch={refetch}  /> 
//       <Gauge4   theme={props.theme} title='Live Power Factor'  refetch={refetch}  /> 
//       </div>

//       {/* <DGConsumption   theme={props.theme} title='Production Chart' />      */}
//     </div> 
//     <GaugeModal 
//           handleOk={handleOk} 
//           handleCancel={handleCancel}
//           open={isModalOpen}
//           UpdateGauge={UpdateGauge}
//         //   setRefetch={setRefetch}
//         //   handleNotification={handleNotification}
//         />   
//   </div>
//   )
// }
// const GaugeModal = ({
//   handleOk,
//   handleCancel,
//   open,
//   loading,
//   handleNotification,
//   UpdateGauge,
// }) => {
//   console.log(open);
//   const mode = useSelector((state) => state.darkMode);

//   const { isdarkMode } = mode;
//   const { makeRequest } = useStoreUpdaterWithAPI();

//   const [group, setGroup] = useState([]);
//   const [converter, setConverter] = useState([]);
//   const [converterID, setConverterID] = useState();
//   const [meter, setMeter] = useState();
//   const [convertermeter, setConverterMeter] = useState([]);
//   const [groupMeter, setGroupMeter] = useState();
//   const [module, setModule]= useState()
  

 
//   // State to hold form values
//   const [formValues, setFormValues] = useState({});
//   const [form] = Form.useForm();

//   // Handle form submission
//   const onFinish = (values) => {
//     console.log(values);
//     console.log(form.getFieldsValue())
  
//     const formData = (values) => {
//       return {
//         converterID: values.ConverterID?.key || null,
//         gaugeID: '1' || null,
//         meterID: values.MeterID.value || null,
//       };
//     };
  
//     const formValues = formData(values);
//     console.log(formValues);
  
//     handleOk();
//     UpdateGauge(formValues);
  
    
//     // **Reset Form Fields**
//     form.resetFields();
  
//     // **Reset States**
//     // setConverterID(null);
//     // setMeter(null);
//     // setConverter([]);
//     // setConverterMeter([]);
//   };
//   // Reset form values when modal is closed
//   useEffect(() => {
//     if (!open) {
//       form.resetFields();
//     } 
//   }, [open, form]);


//   useEffect(() => {
//     makeRequest({
//       type: APIConstants.POST,
//       url:`${APIConstants.ELECTRICAL_GROUP_DETAILS}`,
//     }).then((res) => {
//       console.log(res);
//       if(res){
//         setGroup(res);
//       }
//     });

//     makeRequest({ 
//       type: APIConstants.GET, 
//       // GetFlowSteamGropeMeterDetails?GroupID=81
//       url: `${APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS}`
//     }).then((res) => {
//       console.log(res)
//       setConverter(res);
//     });

//   makeRequest({  
//       type: APIConstants.POST, 
//       // GetFlowSteamGropeMeterDetails?GroupID=81
//       url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`
//     }).then((res) => {
//       console.log(res)
//       // setflowGroupDetailsResData(res);
//     });

//     makeRequest({  
//       type: APIConstants.GET, 
//       url: `${APIConstants.ELECTRICAL_PARAMETER_DETAILS}`
//     }).then((res) => {
//       console.log(res)
//       // setParameter(res);
//     });
//   }, []);
//   console.log(group)

//   useEffect(()=>{
//       makeRequest({ 
//           type: APIConstants.GET,  
//           // GetFlowSteamGropeMeterDetails?GroupID=81
//           url: `${APIConstants.ELECTRICAL_METERS_DETAILS}?ConverterID=${converterID}` 
//         }).then((res) => {
//           console.log(res) 
//           if(res&&res.length>0){
//               setConverterMeter(res);
//           }
//         });
  
//       makeRequest({ 
//           type: APIConstants.POST,  
//           // GetFlowSteamGropeMeterDetails?GroupID=81
//           url: `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${converterID}&Module=1`
//         }).then((res) => {
//           console.log(res)
//           setGroupMeter(res);
//         });
//     },[converterID])

//     const handleConverter=(e)=>{
//       console.log(e)
//       setConverterID(e.value)
//     }
//     const handleClose=()=>{
//       // setMeter()
//       // setConverter([])
//       // setConverterID(null)
//       // setConverterMeter([])
//       handleCancel()
//     }

 
//   console.log(convertermeter)
//   console.log(converterID)

//   return (
//     <Modal
//       open={open}
//       title={<div className={` ${isdarkMode ? "text-white" : "text-black"}`}>
//           Search</div>}
//       // title="Add New Converter"
//       onOk={handleOk}
//       onCancel={handleCancel}
//       // width={800}
//       footer={null}
//       className={` custom-modal ${isdarkMode ? "dark-modal" : "light-modal"}`}
//     >
//       <Form
//         name="Gauge-form"
//         className="font-bold"
//         layout="horizontal"
//         style={{
//           maxWidth: 600,
//         }}
//         labelCol={{
//           span: 8,
//           offset: 0,
//         }}
//         labelAlign="left"
//         onFinish={onFinish}
//         form={form}
//       >
       
//         <Form.Item
//           label="Converter"
//           name="ConverterID"
//           rules={[
//             {
//               required: true,
//               message: "Please select a converter!",
//             },
//           ]}
//         >
//         <Select
//             // value={selectedValue}
//             onChange={handleConverter} 
//             // style={{ width: 200 }}
//             labelInValue
//             placeholder="Select a converter"
//             // dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
//             // className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
//             dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
//             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
//           >
//             {converter.map((i) => (
//               <Option key={i.siteID} value={i.siteID}>
//                 {i.siteName}
//               </Option>
//             ))}
//           </Select>
//         </Form.Item>
//         <Form.Item
//           label="Meter"
//           name="MeterID"
//           rules={[
//             {
//               required: true,
//               message: "Please select a meter!",
//             },
//           ]}
//         >
//         <Select
//             // value={selectedValue}
//             // onChange={handleChange}
//             // style={{ width: 200 }}
//             labelInValue
//             placeholder="Select a meter"
//             // dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
//             // className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
//             dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
//             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
//           >
//             {convertermeter.map((i) => (
//               <Option key={i.metername} value={i.meterid}>
//                 {i.metername}
//               </Option>
//             ))}
//           </Select>
//         </Form.Item>


       

//         <Form.Item
//           wrapperCol={{
//             offset: 16,
//             span: 16,
//           }}
//         >
//           <Button key="back" className="mr-3" onClick={handleClose}>
//             Cancel
//           </Button>
//           ,
//           <Button htmlType="submit" type="primary" loading={loading}>
//             Save
//           </Button>
//         </Form.Item>
//       </Form>
//     </Modal>
//   );
// };
// export default SensorOne



import SensorDataTable from "../hocs/SensorDataTable"; 
import GaugeMain from "../hocs/GaugeMain";
import Chart1 from "../Charts/Chart1";
import DGLive from "../hocs/DGLive";
import DGConsumption from "../hocs/DGConsumption";
 
 

// export default function SensorOne(props) { 
//   return ( 
//     <div className="flex flex-col justify-center bg-dark-echarts my-5 h-fit">
//       <div className="flex xl:flex-nowrap flex-wrap  justify-between bg-dark-echarts gap-5 gap-y-5 m-5">   
//         {/* <SensorDataTable   theme={props.theme} title='VCB Live Data' />  */}
//         {/* <Chart1   theme={props.theme} title='33kV VCB Consumption Trend' />     */}
//       </div>    
//       {/* <GaugeMain  theme={props.theme}/> */}
//     </div>
//   )
// }



const SensorOne = (props) => {
  return (
    <div className="flex flex-col justify-center bg-dark-echarts my-5 h-fit ">
    {/* <div className="flex xl:flex-nowrap flex-wrap  justify-between bg-dark-echarts gap-5 gap-y-5 ">   
      <DGLive   theme={props.theme} title='Production Data' /> 
      <DGConsumption   theme={props.theme} title='Production Chart' />     
    </div>     */}
    <div className="flex xl:flex-nowrap flex-wrap  justify-between bg-dark-echarts gap-5 gap-y-5 ">    
      <SensorDataTable   theme={props.theme} title='EB Incomer' /> 
      <Chart1   theme={props.theme} title='EB Incomer Consumption Trend' />    
    </div>    
    <GaugeMain  theme={props.theme}/>
  </div>
  )
}

export default SensorOne